export enum FileAttachmentTagStatuses {
  flightRequestForm = 'Flight Request Form',
  aviationSpecialistApproval = 'Aviation Specialist Approval',
  airCharterQuote = 'Air Charter Quote',
  airCharterItinerary = 'Air Charter Itinerary',
  organSpecimenPhoto = 'Organ/Specimen Photo',
  flightCostCalculator = 'Flight Cost Calculator',
  cateringReceipt = 'Catering Receipt',
}
